import { z } from 'zod';
import { iamCancerValidation } from '../../../IamCancerSchema';
import { CareDocumentResourceSchema } from '../CareDocumentResourceSchema';
import { CareDocumentDataSchema } from '../CareDocumentDataSchema';
import { IObject } from '../../../IObject';
import { PcpPatientServiceListSchema } from './PcpPatientServiceListSchema';
import { dateValidation, fullNameValidation } from '../../../../validation';

export const PcpDataSchema = CareDocumentDataSchema.extend({
  patient: z.object({
    fullName: fullNameValidation('Patient name is required'),
    dob: dateValidation('Patient date of birth is required'),
    iam: iamCancerValidation("'I am' is a required"),
  }),
  gip: z
    .object({
      code: z.string().optional(),
    })
    .optional(),
  // Aviva has no GIP code; its "Case reference number" is the policy number instead.
  policyNumber: z.string().optional(),
  expertFullName: z.string().optional(),
  expertPhotoUrl: z.string().nullish(),
  dateOfConsultation: dateValidation('Date of consultation is required'),
  notes: z.string().min(1),
  resources: z.array(CareDocumentResourceSchema),
  patientServices: PcpPatientServiceListSchema,
  cancerImpact: z
    .object({
      concern1: z.object({
        concern: z.string().nullish(),
        level: z.string().nullish(),
      }),
      concern2: z.object({
        concern: z.string().nullish(),
        level: z.string().nullish(),
      }),
      feelingLevel: z.string().nullish(),
      psychologicalImpacts: z.array(z.string().min(1)).optional(),
      physicalImpacts: z.array(z.string().min(1)).optional(),
      affectedRelationships: z.array(z.string().min(1)).optional(),
    })
    .optional(),
});

export type PcpData = z.infer<typeof PcpDataSchema>;
export type Pcp = IObject.HasIdTimestamped<PcpData>;
